export default '/pricing/windows3';
